import { ComponentProps, ReactNode } from 'react';
import clsx from 'clsx';

import Icon from '../Icon/Icon';

import styles from './Timeline.module.css';

interface TimelineItem {
  title?: ReactNode;
  description?: ReactNode;
  icon?: ReactNode;
}

interface TimelineProps extends Omit<ComponentProps<'ol'>, 'children'> {
  items: TimelineItem[];
  heading?: ReactNode;
}

export default function Timeline({ items, className, ...props }: TimelineProps) {
  return (
    <ol
      className={clsx(styles.items, className)}
      {...props}
    >
      {items.map(({ title, description, icon }, index) => (
        <li
          key={index}
          className={styles.item}
        >
          <div className={styles.marker}>
            {icon || (
              <Icon
                name="pin"
                className={styles.pin}
              />
            )}
            {index < items.length - 1 ? <div className={styles.line} /> : null}
          </div>

          <div className={clsx(styles.itemContent, !title && styles.noTitle)}>
            {title && <h3 className={styles.itemTitle}>{title}</h3>}
            <div className={styles.itemDescription}>{description}</div>
          </div>
        </li>
      ))}
    </ol>
  );
}
